import CartService from "@/services/cart";

const DISPLAY_MODES = new Set(["last", "all", "none"]);
const UNSAFE_GIFT_URL = /^(javascript|data|vbscript):/i;

function sanitizeGiftUrl(url) {
  if (typeof url !== "string") {
    return "";
  }
  const trimmed = url.trim();
  if (!trimmed || UNSAFE_GIFT_URL.test(trimmed)) {
    return "";
  }
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith("//")) {
    return trimmed;
  }
  return `https://${trimmed}`;
}

export function normalizeConfirmationDisplayMode(mode, showFlag, whenTrue) {
  if (DISPLAY_MODES.has(mode)) {
    return mode;
  }
  if (showFlag === false) {
    return "none";
  }
  return whenTrue;
}

export function collectGiftEntriesFromCart(cart) {
  const items = cart?.items;
  if (!Array.isArray(items)) {
    return [];
  }

  const entries = [];

  for (const item of items) {
    const gifts = CartService.resolveGiftsForCartItem(item, null);
    if (!gifts.length) {
      continue;
    }

    for (const gift of gifts) {
      if (!gift?.name) {
        continue;
      }
      const url = sanitizeGiftUrl(gift.url);
      entries.push({
        name: gift.name,
        url,
      });
    }
  }

  return entries;
}

function lastPurchasedCart(history = []) {
  for (let index = history.length - 1; index >= 0; index -= 1) {
    const cart = history[index]?.cart;
    if (cart) {
      return cart;
    }
  }
  return null;
}

export function resolveConfirmationGiftEntries(history = [], mode = "last") {
  if (mode === "none") {
    return [];
  }

  const carts =
    mode === "all"
      ? history.map((item) => item?.cart).filter(Boolean)
      : [lastPurchasedCart(history)].filter(Boolean);

  const entries = [];
  const seen = new Set();

  for (const cart of carts) {
    for (const entry of collectGiftEntriesFromCart(cart)) {
      const key = entry.url || entry.name;
      if (seen.has(key)) {
        continue;
      }
      seen.add(key);
      entries.push(entry);
    }
  }

  return entries;
}
